import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Game } from 'functions/src/types/firestore/Game';
import { GameTags } from '../game-info/GameTags';
//import { ShareLikedCount } from '../ShareLikedCount';
import { useTheme } from '@mui/material/styles';
import { Link } from '../Link';
// import { useState, useEffect } from 'react';
import { toKebabCase } from 'src/util/string';
import { TypographyParagraphed } from '../TypographyParagraphed';
import Typography from '@mui/material/Typography';

export type VideoBannerDescriptionProps = Pick<
  Game,
  'title' | 'description' | 'tags' | 'likes' | 'id'
>;

export function VideoBannerDescription({
  title,
  description,
  tags,
}: // likes,
// id,
VideoBannerDescriptionProps) {
  const theme = useTheme();

  // const [gameAbsoluteUrl, setGameAbsoluteUrl] = useState('');
  // TODO: Remove
  const isEnabled = !['mobile-legends', 'metaderby'].includes(
    toKebabCase(title),
  );
  const gameUrl = isEnabled ? `/game/${toKebabCase(title)}` : '/';
  // useEffect(() => {
  //   if (!window) {
  //     return;
  //   }
  //   // setGameAbsoluteUrl(`${window.location.hostname}${gameUrl}`);
  // }, [gameUrl]);

  return (
    <Box sx={{ textTransform: 'center', mx: 2 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 4,
        }}
      >
        <Typography
          variant="h4"
          sx={{ fontSize: '28px', textTransform: 'uppercase' }}
        >
          {title}
        </Typography>
        <Link href={gameUrl} sx={{ textDecoration: 'none' }}>
          <Button
            variant="contained"
            disabled={!isEnabled}
            size="large"
            sx={{
              boxShadow: `${theme.shadows[2]}`,
              minWidth: '150px',
            }}
          >
            {isEnabled ? 'play now' : 'coming soon!'}
          </Button>
        </Link>
        {/* <ShareLikedCount
            shareUrl={gameAbsoluteUrl}
            handleLikeParams={{ entityId: id, entityType: 'game' }}
            allLikedKey="likedGameIds"
            id={id}
            likes={likes}
            likeButtonSx={{
              width: '40px',
              height: '40px',
              mt: '-4px',
              mb: '-8px',
              ml: '-4px',
            }}
            likeCountProps={{
              variant: 'h6',
              mt: '4px',
            }}
            shareButtonSx={{
              width: '36px',
              height: '36px',
              mt: '-4px',
              mb: '-8px',
            }}
          /> */}
      </Box>
      {tags && (
        <Box sx={{ mb: 4, mx: 'auto' }}>
          <GameTags tags={tags} />
        </Box>
      )}

      <Box sx={{ maxHeight: '100px', overflowY: 'auto' }}>
        <TypographyParagraphed text={description} />
      </Box>
    </Box>
  );
}
